import { Directive, ElementRef, Input, OnChanges, Renderer2, inject } from '@angular/core';
import { CUSTOM_SYMBOLS } from './custom-symbols';

/**
 * Renders an icon name into a `.material-symbols-outlined` span: the ligature
 * text for Material names, or the inline SVG for a custom icon (see
 * CUSTOM_SYMBOLS). Use it wherever the name comes from an icon map that can
 * hold custom icons, e.g. `<span class="material-symbols-outlined" [cntSymbol]="meta.icon"></span>`.
 */
@Directive({ selector: '[cntSymbol]', standalone: true })
export class CntSymbolDirective implements OnChanges {
  @Input({ required: true }) cntSymbol!: string;

  private el = inject(ElementRef<HTMLElement>);
  private renderer = inject(Renderer2);

  ngOnChanges(): void {
    const svg = CUSTOM_SYMBOLS[this.cntSymbol];
    if (svg) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', svg);
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'textContent', this.cntSymbol ?? '');
    }
  }
}
